---
nb:
  rows:
    connection: kobling
    connections: koblinger
  suppliers:
    add_supplier: Legg til leverandør
    categories:
      advisor_commercial: Kommersiell rådgiver
      advisor_legal: Advokat
      advisor_mna: M&A rådgiver
      advisor_technical: Teknisk rådgiver
      association: Forening
      consultant: Konsulent
      electricity_company: Kraftprodusent
      entrepreneur: Entreprenør
      equipment_supplier: Utstyrsleverandør
      finance: Finans
      grid_owner: Nettleverandør
      insurance: Forsikring
      investor: Investor
      journalist: Journalist
      operation_and_maintenance: Drift & vedlikehold
      other: Annen
      power_trader: Kraft-salg/trading
      risk_management: Risk management
      student: Student
      telecommunication: Teleselskap
    category: Kategori
    roles:
      control_system: Kontrollanlegg
      generator: Generator
      turbine: Turbin
    supplier: Leverandør
    supplier_created: Leverandør opprettet
    supplier_role: Leverandørrolle
    supplier_updated: Leverandør oppdatert
    suppliers: Leverandører
    url_facebook: Facebook
    url_homepage: Nettsted
    url_instagram: Instagram
    url_linked_in: LinkedIn
